export default __webpack_public_path__ + "static/media/kolagenmobile.eb861f53.jpg";